import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { CONTACT_US, CONTACT_US_INFO, OFFICES } from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function ContactsAndOfficesTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    return (
        <HeaderTabsContainer>
            <TabButton
                route={CONTACT_US}
                i18nCode="contactus.navbar.form.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={CONTACT_US_INFO}
                i18nCode="contactus.navbar.contact.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={OFFICES}
                i18nCode="menu.pobockyMapa"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default ContactsAndOfficesTabs;
